// extracted by mini-css-extract-plugin
export default {"navContainer":"profile-nav_navContainer__FrIlq","nav":"profile-nav_nav__s+DSA","navItem":"profile-nav_navItem__zlkh0","textContainer":"profile-nav_textContainer__OCzOq"};